import { ToastContainer, Slide } from "react-toastify";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { RouteName } from "./constants/RouteConstants";
import CallScreens from "./components/CallScreens/CallScreens";
import NetworkConnectionMonitor from "./components/Network/NetworkConnectionMonitor";

// Shared layout (optional)
const CallScreenWrapper = () => (
    <>
        <CallScreens />
    </>
);

const router = createBrowserRouter([
    {
        path: RouteName.DEFAULT_ROUTE, // e.g. "/j"
        element: <CallScreenWrapper />,
    },
    {
        path: RouteName.MEETING_URL, // e.g. "/j/:sessionId"
        element: <CallScreenWrapper />,
    },
    {
        path: "*",
        element: <Navigate to={RouteName.DEFAULT_ROUTE} replace />,
    },
]);

const AllRoutes = () => {
    return (
        <>
            <NetworkConnectionMonitor />
            <ToastContainer
                position='top-right'
                autoClose={5000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover
                className='toast-on-top'
                transition={Slide}
            />
            <RouterProvider router={router} />
        </>
    );
};

export default AllRoutes;
